<template>
    <kgr-form-scaffold
        :pending="pending"
        @primaryBtnClicked="addLocation"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-location-create-form
            :location="location"
            :error="error"
            @enter="addLocation"
        />
    </kgr-form-scaffold>
</template>

<script>

import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import Location from '../../js/dto/resource/Location';
import LocationBasicDataForm from '../../components/resource/LocationBasicDataForm';
import LocationRepository from '../../js/repository/LocationRepository';

export default {
    components: {
        'kgr-location-create-form': LocationBasicDataForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            location: new Location(),
            error: new Error()
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        addLocation() {
            if (this.pending) {
                return;
            }

            this.pending = true;
            LocationRepository.create(this.location)
                .then(id => {
                    this.$notify.success('Ort wurde erstellt', {}, { saveInSession: true });
                    window.location = `/backend/resources/locations/${id}/edit`;
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}



</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
